angular.module('impactx.catalog').controller('CatalogApprovalListTechnicalCtrl', [
    'CatApprovalService',
    '$mdDialog',
    '$route',
    'selectedListItems',
    CatalogApprovalListTechnicalCtrl
]);

function CatalogApprovalListTechnicalCtrl(CatApprovalService, $mdDialog, $route, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
        },
        {
            label: "approve",
            action: approveCatalogs,
            condition: selectedListItems.isMultiSelection,
        },
        {
            label: "deny",
            action: denyCatalogs,
            condition: selectedListItems.isMultiSelection,
        },
        {
            label: "stop",
            action: stopCatalog,
            condition: mayStop,
        }
    ];
    this.meta = {
        rowTemplate: 'modules/catalog/approval/templates/catalog.approval.row.tmpl.html',
        buttonDefinition: buttonDefinition,
        isSelectAble: true,
        endpoint: '/catalog/list/approval/technical',
        ctrl: this,
        id: "catalog.approval.technical",
        idColumn: "atiId",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function approveCatalogs() {
        var atiIds = selectedListItems.getSelectedIds();
        CatApprovalService.approveCatalogs(atiIds, $route.reload);
    }

    function denyCatalogs() {
        var atiIds = selectedListItems.getSelectedIds();

        CatApprovalService.denyCatalogs(atiIds, $route.reload);
    }

    function stopCatalog(event) {
        var catId = selectedListItems.getFirstSelectedId();
        CatApprovalService.stopCatalog(catId, $route.reload, event);
    }

    function getDetailLink() {
        return "catalogqualitymanagement/" + selectedListItems.getFirstSelectedId();
    }

    function mayStop() {
        return selectedListItems.isMultiSelection() && selectedListItems.getFirstSelectedItem().mayStop;
    }
}
